// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pre { white-space:pre; display: block; }`, "",{"version":3,"sources":["webpack://./src/app/components/v-address/v-address.component.ts"],"names":[],"mappings":"AAAA,OAAO,eAAe,EAAE,cAAc,EAAE","sourcesContent":[".pre { white-space:pre; display: block; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
